import { ITableJoinMeta } from '../../../../utils/apollo/graphqlSchema';
import { ViewRowDiv, ViewSection } from './SchemaEntityRelationsUI';
import { getJoinPairMetasStr, getTemporalConditionStr } from '../utils';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  meta: ITableJoinMeta;
}

const TableJoinMeta = ({ meta }: IProps) => {
  const { joinPairs, temporalCondition } = meta;
  const joinPairsStr = getJoinPairMetasStr(joinPairs);
  const temporalConditionStr = getTemporalConditionStr(temporalCondition);

  return (
    <ViewSection>
      <KubitTooltip content={'Join on: ' + joinPairsStr} placement="right">
        <ViewRowDiv>{'Join on: ' + joinPairsStr}</ViewRowDiv>
      </KubitTooltip>
      {temporalConditionStr && (
        <KubitTooltip
          content={'Temporal: ' + temporalConditionStr}
          placement="right"
        >
          <ViewRowDiv>{'Temporal: ' + temporalConditionStr}</ViewRowDiv>
        </KubitTooltip>
      )}
    </ViewSection>
  );
};

export default TableJoinMeta;
